import React from 'react';
import { motion } from 'framer-motion';
import { Download, Package } from 'lucide-react';

const Kits: React.FC = () => {
  return (
    <div className="min-h-screen">
      <section className="relative py-24 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#D4A5A5]/10 to-[#9CAF88]/10" />

        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="font-sans text-sm text-[#D4A5A5] font-medium tracking-wider uppercase mb-4 block">
              Coming Soon
            </span>

            <div className="inline-flex items-center justify-center w-20 h-20 bg-[#C9A962]/20 rounded-full mb-8">
              <Package className="w-10 h-10 text-[#C9A962]" />
            </div>

            <h1 className="font-serif text-5xl sm:text-6xl font-semibold text-[#3D3D3D] leading-tight mb-6">
              Bible Journaling Host Kit
            </h1>

            <p className="font-sans text-lg text-[#3D3D3D]/70 leading-relaxed mb-10 max-w-2xl mx-auto">
              Comes with all you need to start your own bible journaling group from where you are.
            </p>

            <button
              type="button"
              disabled
              aria-disabled="true"
              className="inline-flex items-center justify-center gap-2 bg-gray-300 text-gray-500 px-8 py-4 font-sans rounded-full cursor-not-allowed"
            >
              <Download className="w-5 h-5" />
              Download — Coming Soon
            </button>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Kits;
